import {ApiResponse} from '../models/ApiResponse';
import {GradebookModel} from '../models/Course/Gradebook';
import {
  CourseAnalyticsData,
  CourseAnalyticsLearnerDetails,
  CourseLearnersAnalyticsItem,
} from '../models/Gradebook/CourseAnalyticsModels';
import {
  CourseAvgGradesModel,
  LearnerAvgGradesModel,
} from '../models/Gradebook/LearnerAvgGradesModel';
import {LearnerJourney} from '../models/LessonContent/LearnerJourney';
import {apiClient, withAuth} from './baseApiClient';

class GradebookAPI {
  public async getCourseGradebook(
    organizationId: string,
    courseId: string,
  ): Promise<ApiResponse<GradebookModel>> {
    const headers = await withAuth({});
    return apiClient.get(
      `/gradeBook/${organizationId}/${courseId}/lesson_grades`,
      {headers},
    );
  }

  public async getLearnerProgressDetails(
    courseId: string,
    lessonId: string,
    learnerId: string,
  ): Promise<ApiResponse<LearnerJourney>> {
    return apiClient.get(
      `lessons/course/${courseId}/lesson/${lessonId}/learner/${learnerId}/learnerLessonProgresDetails`,
    );
  }

  public async getCoursesAvgGrades(
    organizationId: string,
  ): Promise<ApiResponse<CourseAvgGradesModel>> {
    return apiClient.get(`/gradeBook/${organizationId}/avg_course_grades`);
  }

  public async getCourseLearnersAnalytics(
    organizationId: string,
    courseId: string,
  ): Promise<ApiResponse<CourseLearnersAnalyticsItem[]>> {
    return apiClient.get(
      `/gradeBook/${organizationId}/course_analytics/${courseId}/learners`,
    );
  }

  public async getCourseAnalytics(
    organizationId: string,
    courseId: string,
  ): Promise<ApiResponse<CourseAnalyticsData>> {
    return apiClient.get(
      `/gradeBook/${organizationId}/course_analytics/${courseId}`,
    );
  }

  public async getCourseLearnerAnalyticsDetails(
    organizationId: string,
    courseId: string,
    learnerId: string,
  ): Promise<ApiResponse<CourseAnalyticsLearnerDetails>> {
    return apiClient.get(
      `/gradeBook/${organizationId}/course_analytics_learners/${courseId}/${learnerId}`,
    );
  }

  public async getLearnersWithAvgScores(
    organizationId: string,
    page: number,
    pageSize: number,
    search: string,
    orderAsc: boolean,
  ): Promise<ApiResponse<LearnerAvgGradesModel>> {
    return apiClient.post(
      `/gradeBook/${organizationId}/avg_learner_course_grades`,
      {page, pageSize, search, orderAsk: orderAsc},
    );
  }

  public async changeLearnerLessonGrade(
    organizationId: string,
    courseId: string,
    learnerId: string,
    lessonId: string,
    newGrade: number,
  ): Promise<ApiResponse<void>> {
    const headers = await withAuth({});
    return apiClient.post(
      `/gradeBook/${organizationId}/course_analytics_learners/course/${courseId}/learner/${learnerId}/lesson/${lessonId}/change_grade?newGrade=${newGrade}`,
      {},
      {headers},
    );
  }
}

export default GradebookAPI;
